import { deviceJudge } from "@/utils/common";
import request from "@/utils/request/index";
export enum Api {
  UPDATE_USERINFO = "/userCenter/updateInfo",
  FETCH_USERINFO = "/userCenter/info",
  DATA_COLLECT = "/dataCollect/create",
}
// 修改用户信息
export const updateUserInfo = (data?: any, config?: axiosConfig) =>
  request.post(Api.UPDATE_USERINFO, data, config);

// 获取用户信息
export const fetchUserInfo = (data?: any) =>
  request.get(Api.FETCH_USERINFO, data);

export const dataCollect = (data?: any, config?: axiosConfig) => {
  const defaultConfig = {
    fieldType: [],
    number: 1,
    pageTitle: "",
    payAmount: "",
    terminal: deviceJudge(),
    // projectCode: "",
  };
  return request.post(
    Api.DATA_COLLECT,
    Object.assign(defaultConfig, data),
    config
  );
};
